<template>
<div class="content-body tenant-settings">
    <el-tabs v-model="activeName" @change="changeTabHandle">
        <el-tab-pane :key="1" label="包装运输费统计" name="costPage">
            <el-form :model="dataForm" :rules="dataRule" size="mini" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="150px" class="org-dialog-form" v-loading="dataFormLoading">
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="每个零件运输成本" prop="boxCost">
                            {{fixedNumber(dataForm.transportCost)}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="每个包装箱体积(m³)" prop="boxVolume">
                            <ctl-number v-model="dataForm.boxVolume" maxlength="200" :min="0" :max="1000000000"></ctl-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="每箱中零件数量" prop="partNum">
                            <ctl-number v-model="dataForm.partNum" maxlength="200" :min="0" :max="1000000000"></ctl-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="每m³运费(元/m³)" prop="transportFee">
                            <ctl-number v-model="dataForm.transportFee" maxlength="200" :min="0" :max="1000000000"></ctl-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <!-- <el-form-item label="询报价ID">
                            <el-input v-model="dataForm.rfqId" placeholder="询报价ID" style="width:300px" maxlength="10"></el-input>
                        </el-form-item>
                        <el-form-item label="零件ID">
                            <el-input v-model="dataForm.partId" placeholder="零件ID" style="width:300px" maxlength="10"></el-input>
                        </el-form-item>
                        <el-form-item label="供应商ID">
                            <el-input v-model="dataForm.supplierId" placeholder="供应商ID" style="width:300px" maxlength="10"></el-input>
                        </el-form-item> -->
                        <el-form-item label="计算公式">
                            每个包装箱体积(m³) ÷ 每箱中零件数量 * 每m³运费(元/m³) = 每个零件运输成本
                        </el-form-item>
                        <!-- <el-form-item label="轮次">
                            <el-input v-model="dataForm.roundNo" placeholder="轮次" style="width:300px" maxlength="10"></el-input>
                            {{dataForm.roundNo}}
                        </el-form-item> -->
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="每个包装箱成本" prop="boxCost">
                            {{fixedNumber(dataForm.boxCost)}}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :span="12">
                        <!-- <el-form-item label="询报价ID">
                            <el-input v-model="dataForm.rfqId" placeholder="询报价ID" style="width:300px" maxlength="10"></el-input>
                        </el-form-item>
                        <el-form-item label="零件ID">
                            <el-input v-model="dataForm.partId" placeholder="零件ID" style="width:300px" maxlength="10"></el-input>
                        </el-form-item>
                        <el-form-item label="供应商ID">
                            <el-input v-model="dataForm.supplierId" placeholder="供应商ID" style="width:300px" maxlength="10"></el-input>
                        </el-form-item> -->
                        <el-form-item label="计算公式">
                            每个包装箱成本 ÷ 每箱中零件数量 = 每个零件包装成本
                        </el-form-item>
                        <!-- <el-form-item label="轮次">
                            <el-input v-model="dataForm.roundNo" placeholder="轮次" style="width:300px" maxlength="10"></el-input>
                            {{dataForm.roundNo}}
                        </el-form-item> -->
                    </el-col>
                </el-row>
            </el-form>
            <el-row :gutter="40">
                <el-col :span="8" style="text-align:center">
                    <el-button size="small" type="primary" plain v-if="isAuth('sourcing:quotation:newbuttonDetail') && viewFlag !== 'view'" @click="dataFormSubmit()">
                        保存
                    </el-button>
                    <el-button size="small" icon="el-icon-refresh" plain @click="loadFormData()">
                        刷新
                    </el-button>
                </el-col>
            </el-row>
        </el-tab-pane>
        <el-tab-pane :key="2" label="包装箱成本明细" name="detailPage">
            <el-row style="text-align:right; margin-bottom:15px">
                <el-col>
                    <el-button size="mini" v-if="isAuth('sourcing:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">
                        新建
                    </el-button>
                    <el-button size="mini" icon="el-icon-refresh" plain @click="reLoadData2()">
                        刷新
                    </el-button>
                </el-col>
            </el-row>
            <el-table :data="dataList" row-key="id" size="mini" border style="width: 100%;" :header-cell-style="{background:'#f5f5f5'}" :default-expand-all="false" :height="tableHeight" v-loading="dataListLoading">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="materialName" header-align="center" align="left" label="材料名称"></el-table-column>
                <el-table-column prop="userdNum" header-align="center" align="right" label="使用量"></el-table-column>
                <el-table-column prop="unitPrice" header-align="center" align="right" label="单价">
                </el-table-column>
                <el-table-column header-align="center" align="left" width="100" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <!--<el-button type="text" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>-->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20,50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshBoxDataList="getDataList"></add-or-update>
        </el-tab-pane>
    </el-tabs>

</div>
</template>

<script>
import {
    boxGetByParam,
    boxDetailDelete,
    boxDetailList,
    boxInsert,
    boxUpdate
} from '@/controller/quotation'
import AddOrUpdate from './quotationBox-add-or-update'
import moment from 'moment'
import {
    mapping
} from "@/utils"
import CtlNumber from '@/views/common/ctl-number'
// require('@/mock/mockQuotation');
export default {
    components: {
        AddOrUpdate,
        CtlNumber
    },
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            activeName: '',
            dataForm: {
                id: '',
                rfqId: '',
                rfqPartId: '',
                rfqSupplierId: '',
                roundNo: '',
                boxCost: 0,
                partNum: 0,
                boxVolume: 0,
                transportFee: 0,
                transportCost: 0,
            },
            viewFlag: '',
            dataRule: {},
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataFormLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false
        }
    },
    watch: {
        'dataForm.partNum': { // 监听对象的某个键
            handler(nval, oval) { // 监听成功
                //console.log('dataForm.partNum', nval)
                // 每个包装箱体积(m³) ÷ 每箱中零件数量 * 每m³运费(元/m³) = 每个零件运输成本
                if (this.dataForm.partNum * nval !== 0) {
                    this.dataForm.transportCost = this.dataForm.boxVolume / nval * this.dataForm.transportFee
                } else {
                    this.dataForm.transportCost = 0
                }
            },
            deep: true, // 深度监听
        },
        'dataForm.boxVolume': { // 监听对象的某个键
            handler(nval, oval) { // 监听成功
                // 每个包装箱体积(m³) ÷ 每箱中零件数量 * 每m³运费(元/m³) = 每个零件运输成本
                if (this.dataForm.partNum * nval !== 0) {
                    this.dataForm.transportCost = nval / this.dataForm.partNum * this.dataForm.transportFee
                } else {
                    this.dataForm.transportCost = 0
                }
            },
            deep: true, // 深度监听
        },
        'dataForm.transportFee': { // 监听对象的某个键
            handler(nval, oval) { // 监听成功
                if (this.dataForm.partNum * nval !== 0) {
                    this.dataForm.transportCost = this.dataForm.boxVolume / this.dataForm.partNum * nval
                } else {
                    this.dataForm.transportCost = 0
                }
            },
            deep: true, // 深度监听
        },

    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 325
            }
        }
    },
    // activated() {
    //     this.init(1, 1, 1);
    // },
    methods: {

        // init(rfqId = 0, roundNo = 0, supplierId = 0) {
        //     this.dataForm.rfqId = rfqId;
        //     this.dataForm.roundNo = roundNo;
        //     this.dataForm.supplierId = supplierId;
        //     boxGetByParam({
        //         'rfqId': rfqId,
        //         'roundNo': roundNo,
        //         'supplierId': supplierId
        //     }).then(data => {
        //         if (data && data.code === '00' && data.body) {
        //             this.dataForm = data.body
        //             this.getDataList()
        //         }
        //     });

        // },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        init(rfqId = 0, rfqPartId = 0, supplierId = 0, roundNo = 0, viewFlag) {
            this.activeName = 'costPage'
            this.dataForm.rfqId = rfqId
            this.dataForm.rfqPartId = rfqPartId
            this.dataForm.rfqSupplierId = supplierId
            this.dataForm.roundNo = roundNo
            this.dataForm.id = 0
            this.viewFlag = viewFlag
            this.pageIndex = 1
            this.loadFormData();
            //this.getDataList()
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true

            boxDetailList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                totalPage: this.totalPage,
                boxTriansportId: this.dataForm.id
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
                setTimeout(() => {
                    this.dataListLoading = false
                }, 200)

            })
        },
        loadFormData() {
            let {
                rfqId,
                rfqPartId,
                rfqSupplierId,
                roundNo
            } = this.dataForm;
            // this.dataFormLoading = true;
            boxGetByParam({
                rfqId,
                rfqPartId,
                rfqSupplierId,
                roundNo
            }).then(data => {
                if (data && data.code === '00' && data.body) {
                    mapping(data.body, this.dataForm);
                    this.getDataList();
                }
            });

        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, this.dataForm.id, 'view', this.dataForm)
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            //console.log("new")
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, this.dataForm.id, 'edit', this.dataForm)
            })
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                boxDetailDelete({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                let params = this.dataForm
                if (valid) {
                    if (this.dataForm.id) {
                        boxUpdate(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {}
                                })
                                this.loadFormData()
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        boxInsert(params).then(data => {
                            if (data && data.code === '00') {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {}
                                })
                                this.loadFormData()
                            } else {
                                this.$message.error(data.msg)
                            }

                        })
                    }
                }
            })
        },
        reLoadData2() {
            // let {
            //     rfqId,
            //     supplierId,
            //     roundNo
            // } = this.dataForm;
            this.pageIndex = 1
            this.getDataList()
        },
        fixedNumber(val) {
            if (!val) {
                return 0
            }
            return Number(Number(val).toFixed(3))
        },
        changeTabHandle(val) {
            if (this.activeName === 'costPage') {
                this.loadFormData()
            }
        }
    }
}
</script>
